/**
 * Generated runtime TestId mirror for frontend/src/pages/FunctionGroupRequests.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const FunctionGroupRequestsTestIds = {
  btnCreateFgRequest: "btn-create-fg-request",
  colBeneficiary: "col-beneficiary",
  colCreatedAt: "col-created-at",
  colItems: "col-items",
  colJustification: "col-justification",
  colRequester: "col-requester",
  colStatus: "col-status",
  functionGroupRequestsList: "function-group-requests-list",
  linkFgRequestDetail: (request_id: string) => `link-fg-request-detail-${request_id}`,
  linkFgRequestDetailPrefix: () => "link-fg-request-detail-" as TestIdPrefix
} as const;
